export const toolClasses = {
  arrow: 't-btn-control-panel-item-arrow',
  path: 't-btn-control-panel-item-path',
  line: 't-btn-control-panel-item-straight-line',
  rect: 't-btn-control-panel-item-rect',
  circle: 't-btn-control-panel-item-circle',
  triangle: 't-btn-control-panel-item-triangle',
  unselect: 't-btn-control-panel-item-unselect',
};

// This is the id for all drawer objects.
export const drawObjectInProgressId = 'drawObjectInProgressId';

export const colorPickerDefaultColors = [
  '#000',
  '#fff',
  '#43C0A2',
  // '#C2DCF3',
  '#ED7C7C',
  '#E3C65D',
  '#96B9DA',
];

export const shapeDefaults = {
  borderWidth: 4,
  borderColor: '#96B9DA',
  borderRadius: 8,
  borderStyle: 'solid',
  backgroundColor: '#c2dcf3',
};
